import { render, staticRenderFns } from "./file-preivew-item.vue?vue&type=template&id=ec8158c4&scoped=true&"
import script from "./file-preivew-item.vue?vue&type=script&lang=js&"
export * from "./file-preivew-item.vue?vue&type=script&lang=js&"
import style0 from "./file-preivew-item.vue?vue&type=style&index=0&id=ec8158c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8158c4",
  null
  
)

export default component.exports